import { client } from "./client"
import { safeQueryOptions } from "@src/utils/query"

export const literalsKeys = {
  all: ["literals"] as const,
  byCommunity: (id?: number) => [...literalsKeys.all, id],
}

export const getCommunityLiterals = async (communityId: number) => {
  return await client.GET("/api/CommunityLiteral/GetByCommunity", {
    params: {
      query: {
        communityId,
      },
    },
  })
}

export const getCommunityLiteralsQuery = (id?: number) =>
  safeQueryOptions({
    queryFn: getCommunityLiterals,
    queryKeys: literalsKeys.byCommunity(id),
    unsafeQueryFnArgs: [id],
    staleTime: 1000 * 60 * 60 * 24, // 24 hours — rarely changes, no need to refetch often
    gcTime: 1000 * 60 * 60 * 24 * 30,
  })

export type CommunityLiterals = {
  primitive_startup?: string
  primitive_startups?: string
  primitive_program?: string
  primitive_programs?: string
  [key: string]: string | undefined
}

// Backend literal keys that aren't translation-catalog message IDs. The
// catalog-driven literals editor can't see these, so it must preserve them
// explicitly — otherwise the replace-all save deletes them.
export const PRIMITIVE_LITERAL_KEYS = [
  "primitive_startup",
  "primitive_startups",
  "primitive_program",
  "primitive_programs",
] as const

export const saveCommunityLiterals = async (
  communityId: number,
  literals: CommunityLiterals,
) => {
  // Filter out undefined values for the API
  const cleanLiterals: { [key: string]: string } = {}
  for (const [key, value] of Object.entries(literals)) {
    if (value !== undefined && value !== "") {
      cleanLiterals[key] = value
    }
  }

  return await client.POST("/api/CommunityLiteral/Save/{communityId}", {
    params: {
      path: {
        communityId,
      },
    },
    body: cleanLiterals,
  })
}
